import { render, staticRenderFns } from "./atendimentos.vue?vue&type=template&id=b88fd80a"
import script from "./atendimentos.ts?vue&type=script&lang=js&external"
export * from "./atendimentos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88fd80a')) {
      api.createRecord('b88fd80a', component.options)
    } else {
      api.reload('b88fd80a', component.options)
    }
    module.hot.accept("./atendimentos.vue?vue&type=template&id=b88fd80a", function () {
      api.rerender('b88fd80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/atendimentos/atendimentos.vue"
export default component.exports